export const validUrlRegexp = new RegExp(/(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w-]*)?(\?[^\s]*)?/i)

export const validLoomRegexp = new RegExp(/(https?:\/\/)?loom.com\/(share|embed)\/([a-z|0-9]*)/i)
